import { createSelector, createSlice } from "@reduxjs/toolkit";
import {
  getSessionsMarkers,
  getWellnessMarkers,
} from "../markers/markersSlice";
import { selectAuth } from "../auth/authSlice";
import { statsCollectiveActions } from "../statsCollective/statsCollectiveSlice";
import { statsIndivActions } from "../statsIndiv/statsIndivSlice";

const slice = createSlice({
  name: "lang",
  initialState: {
    pref: localStorage.getItem("user_language_preference") || "en",
    translations: {},
  },
  reducers: {
    setTranslations: (state, action) => {
      state.translations = action.payload;
    },
    setLanguage: (state, action) => {
      localStorage.setItem("user_language_preference", action.payload);
      state.pref = action.payload;
    },
  },
});

export default slice.reducer;
export const langActions = slice.actions;

export const changeLang = (lang) => {
  return async (dispatch, getState) => {
    const currentLang = selectLang(getState());

    if (lang === currentLang) return;

    dispatch(langActions.setLanguage(lang));

    const { isAuth } = selectAuth(getState());
    if (isAuth) {
      dispatch(getWellnessMarkers({ ignoreCondition: true }));
      dispatch(getSessionsMarkers({ ignoreCondition: true }));
      dispatch(statsCollectiveActions.invalidateCache());
      dispatch(statsIndivActions.invalidateCache());
    }
  };
};

export const loadTranslations = (lang) => async (dispatch) => {
  try {
    const translations = await import(`./locales/${lang}.json`);
    dispatch(langActions.setTranslations(translations.default));
  } catch (error) {
    console.error("Erreur de chargement des traductions :", error);
  }
};

export const selectLang = (state) => state.lang.pref;

export const selectTxt = createSelector(
  [(state) => state.lang.translations, (state, sectionName) => sectionName],
  (translations, sectionName) => {
    return translations?.[sectionName] || {};
  }
);

export const selectDefaultErrorMessage = (state) =>
  selectTxt(state, "global").errorMessage;

export const selectDefaultSuccessMessage = (state) =>
  selectTxt(state, "global").successMessage;

export const selectAlertsTexts = createSelector(
  [
    (state) => selectTxt(state, "requests"),
    (state) => selectDefaultErrorMessage(state),
    (state) => selectDefaultSuccessMessage(state),
  ],
  (requestsText, defaultErrorText, defaultSuccessText) => {
    return {
      requestsText,
      defaultErrorText,
      defaultSuccessText,
    };
  }
);

export const selectTranslations = (state) => state.lang.translations;

export const selectColModTitle = createSelector(
  (state) => selectTxt(state, "collectif"),
  (_, modId) => modId,
  (txt, modId) => txt.modulesTitles[modId]
);

export const selectColModDescription = createSelector(
  (state) => selectTxt(state, "collectif"),
  (_, modId) => modId,
  (txt, modId) => txt.modDescriptions[modId]
);

export const selectIndivModTitle = createSelector(
  (state) => selectTxt(state, "indiv"),
  (_, modId) => modId,
  (txt, modId) => txt.modulesTitles[modId]
);

export const selectIndivModDescription = createSelector(
  (state) => selectTxt(state, "indiv"),
  (_, modId) => modId,
  (txt, modId) => txt.modDescriptions[modId]
);
